import type { FaireProductEntity } from "../../entity_types/product";

export const p_5npwd9k9wg: FaireProductEntity = {
  token: "p_5npwd9k9wg",
  type: "product",
  name: "18K Gold-Filled Evil Eye Multi-Stone Stacking Ring",
  brandToken: "b_7ef699gcdg",
  brandName: "Beads Creation",
  imageUrl:
    "https://cdn.faire.com/fastly/d986d6349c73a28eb1dd0c6042711ebff8b177e311c4de5ccacacc0400df3239.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/18baf21a9bdf2838124f83e26bb967f295684ea6ac13374908c22d438961f35f.jpeg",
    "https://cdn.faire.com/fastly/2146c47499154a06a6ede1316543514a6c83ee4c4052efe66efdc1a669f9bfea.jpeg",
    "https://cdn.faire.com/fastly/bb29aeefb57424441128c07534c2f2ad71629d36fbc43bb007a93c6b2f04c0e9.jpeg",
    "https://cdn.faire.com/fastly/0958e08f1869380599aca422090e5199e5d3a987838b273bdf9c19566b734321.jpeg",
    "https://cdn.faire.com/fastly/9d663e3b8396171de57a376c65514cfa2717de63275fe39de8b7e2c7ab738642.jpeg",
    "https://cdn.faire.com/fastly/ce06711082ad8e7ca0ee84bfb4a3781096118074e141160f21d972582e2a1aea.jpeg",
    "https://cdn.faire.com/fastly/3c40c40024cf9c4991006f11ab0a7fcb0fb95568793fe2446f47ac2140ceb645.jpeg",
  ],
  priceDollars: 7.15,
  description:
    "Creating your handcrafted jewelry pieces starts here! This is the best place to shop for fashionable and stylish jewelry findings with premium quality and competitive price!\nTake a look at more detail information about this item:\n\nSuch a cute and Bold Link ring! It's a Chunky, everyday ring that is elegant, chic, and trendy. It is perfect for all ages, and as a gift.\nThis listing is for ONE Adjustable ring only.\nDescription: \nMaterial: Brass Based with 18K Gold Filled, Cubic Zirconia\nSize: 20mm\nQTY: 1PC\n\n★Ship from CA, USA★\n\nAll sizes are approximate \nLead Free & Cadmium Free & Nickel Free\n\nIf you any questions regarding our products, bulk discount, and issue please send us a message\nThank you for your visit!",
  tags: [],
  msrpDollars: 8.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:10.023Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
